<template>
  <div>
    <vs-alert
      color="danger"
      :title="errorMsg"
      :active.sync="hasError"
    >
    </vs-alert>
    <vx-card v-if="!hasError" class="overlay-card overflow-hidden">
      <div slot="no-body">
        <!-- Map -->
        <div id="vessel-position-map" class="vs-con-loading__container">
          <vessel-voyage-history-map
            v-if="voyageHistoryDateTime"
            :vessel_id="voyageHistoryDateTime.vesselId"
            :vessel_name="vesselName"
            :start_time="voyageHistoryDateTime.startTimeUtc"
            :end_time="voyageHistoryDateTime.endTimeUtc"
            class="responsive card-img-top"
            @onClickPrev="onClickPrev"
            @onClickNext="onClickNext"
          ></vessel-voyage-history-map>
        </div>
      </div>
      <!-- カメラ -->
      <div
        id="vessel-position-live-camera-area"
        class="mapboxgl-ctrl-top-right"
      >
        <div class="mapboxgl-ctrl">
          <!-- ヒストリーカメラ -->
          <vs-row v-if="voyageHistoryDateTime" vs-align="flex-start">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="cameraVsw"
            >
              <vx-card class="overflow-hidden live-camera-card">
                <template slot="no-body">
                  <div
                    :key="index"
                    v-for="(camera, index) in historyCamerasRow1"
                  >
                    <vessel-voyage-history-camera
                      :camera="camera"
                      :startTimeUtc="voyageHistoryDateTime.startTimeUtc"
                      :endTimeUtc="voyageHistoryDateTime.endTimeUtc"
                    ></vessel-voyage-history-camera>
                  </div>
                </template>
              </vx-card>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="cameraVsw"
            >
              <vx-card class="overflow-hidden live-camera-card">
                <template slot="no-body">
                  <div
                    :key="index"
                    v-for="(camera, index) in historyCamerasRow2"
                  >
                    <vessel-voyage-history-camera
                      :camera="camera"
                      :startTimeUtc="voyageHistoryDateTime.startTimeUtc"
                      :endTimeUtc="voyageHistoryDateTime.endTimeUtc"
                    ></vessel-voyage-history-camera>
                  </div>
                </template>
              </vx-card>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <div id="timeline-controller-container" class="mt-2">
        <timeline-controller
          v-if="vessel"
          :vesselId="vessel.id"
          :startTimeUtc="startTimeUtc"
          :endTimeUtc="endTimeUtc"
          :enableTime="enableTime"
          :timeLabel="timeLabel"
          ref="timeLineController"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
import "mapbox-gl/dist/mapbox-gl.css";
import { createNamespacedHelpers } from "vuex";
import { DateUtil } from "@/utils";
import moment from "moment";

// components
import TimelineController from "./components/TimeLineControl";
import VesselVoyageHistoryMap from "@/views/enterprise/management/vessels/vessel-view/components/cardVesselPosition/components/VesselVoyageHistoryMap";
import VesselVoyageHistoryCamera from "@/views/enterprise/management/vessels/vessel-view/components/cardVesselPosition/components/VesselVoyageHistoryCamera";

// Store
const {
  mapActions: mapActionsOfVesselView,
  mapState: mapStateOfVesselView
} = createNamespacedHelpers("enterpriseVesselView");
const {
  mapActions: mapActionsOfVesselVoyageHistory,
  mapState: mapStateOfVesselVoyageHistory
} = createNamespacedHelpers("enterpriseVesselVoyageHistory");

export default {
  name: "VesselPosition",
  components: {
    VesselVoyageHistoryMap,
    VesselVoyageHistoryCamera,
    TimelineController
  },
  data() {
    return {
      hasError: false,
      errorMsg:"",
      vessel: null,
      vesselName: null,
      startTimeUtc: null,
      endTimeUtc: null,
      startTimeLocal: null,
      endTimeLocal: null,
      enableTime: null,
      enableTo: null,
      timeLabel: "12",
      initialized: false,
      cameras: null,
      cameraVsw: "12",
      subscribe: null,
      historyCamerasRow1: [],
      historyCamerasRow2: []
    };
  },
  computed: {
    ...mapStateOfVesselView({
      mode: state => state.mode,
      voyageHistoryDateTime: state => state.voyageHistoryDateTime
    }),
    ...mapStateOfVesselVoyageHistory({
      isWaitingBuffered: state => state.is_waiting_buffered,
    })
  },
  methods: {
    ...mapActionsOfVesselView([
      "setVoyageHistoryDateTime",
      "fetchCameras",
      "resetEnterpriseVesselViewState",
      "fetchVoyageHistoryDetail"
    ]),
    ...mapActionsOfVesselVoyageHistory([
      "resetVoyageHistoryState",
    ]),

    async setHistoryCameras() {
      let cameras = await this.fetchCameras(this.vesselId);
      switch (cameras.length) {
        case 1:
          this.historyCamerasRow1 = cameras;
          break;
        case 2:
          this.historyCamerasRow1 = cameras;
          break;
        case 3:
          this.cameraVsw = 6;
          this.historyCamerasRow1.push(cameras[0]);
          this.historyCamerasRow1.push(cameras[1]);
          this.historyCamerasRow2.push(cameras[2]);
          break;
        case 4:
          this.cameraVsw = 6;
          this.historyCamerasRow1.push(cameras[0]);
          this.historyCamerasRow1.push(cameras[1]);
          this.historyCamerasRow2.push(cameras[2]);
          this.historyCamerasRow2.push(cameras[3]);
          break;
      }
    },

    rounding30min(target) {
      let res;
      let mm = Number(target.split(":")[1]);
      if (mm >= 30) {
        res = `${target.split(":")[0]}:30:00`;
      } else {
        res = `${target.split(":")[0]}:00:00`;
      }
      return res;
    },

    rounding30minForEnd(target) {
      let res;
      let hh = Number(target.split(":")[0]);
      let mm = Number(target.split(":")[1]);
      if (mm <= 30) {
        res = `${hh}:30:00`;
      } else {
        res = `${hh + 1}:00:00`;
      }
      return res;
    },

    cleanup() {
      this.resetEnterpriseVesselViewState();
      this.resetVoyageHistoryState();
    },
    onClickPrev() {
      this.$refs.timeLineController.onClickPrev();
    },
    onClickNext() {
      this.$refs.timeLineController.onClickNext();
    },

    setTargetPlayTime(startUtcTime, endUtcTime) {
      const startUtcTimeMoment = DateUtil.toMomentObj(startUtcTime).utc();
      const endUtcTimeMoment = DateUtil.toMomentObj(endUtcTime).utc();

      const targetDayLocal = startUtcTimeMoment.format("YYYY-MM-DD");

      const startTimeLocal = startUtcTimeMoment.format("HH:mm:ss");

      const startLocal = `${targetDayLocal}T${DateUtil.rounding10min(
        startTimeLocal
      )}`;

      const endTimeLocal = endUtcTimeMoment.format(
        "HH:mm:ss"
      );

      const endLocal = `${targetDayLocal}T${DateUtil.rounding10min(
        endTimeLocal
      )}`;

      const startUtc = startUtcTimeMoment
        .format("YYYY-MM-DDTHH:mm:ss");

      const endUtc = endUtcTimeMoment.format(
        "YYYY-MM-DDTHH:mm:ss"
      );

      this.startTimeUtc = `${startUtc}.000Z`;
      this.endTimeUtc = `${endUtc}.000Z`;
      this.startLocal = `${startLocal}.000Z`;
      this.endLocal = `${endLocal}.000Z`;
    },

    setPlayableTime(voyageStartUtcTime, voyageEndUtcTime, targetStartUtcTime, targetEndUtcTime) {
      this.enableTime = {
        fromLocal: DateUtil.toMomentObj(voyageStartUtcTime).local().format("YYYY-MM-DDTHH:mm:ss"),
        toLocal: DateUtil.toMomentObj(voyageEndUtcTime).local().format("YYYY-MM-DDTHH:mm:ss"),
      };

      let playableStartTimeLabel;
      let playableEndTimeLabel;

      if (DateUtil.isSameLocalDate(voyageStartUtcTime, targetStartUtcTime)) {
        if (DateUtil.toMomentObj(voyageStartUtcTime).isAfter(DateUtil.toMomentObj(targetStartUtcTime))) {
          playableStartTimeLabel = DateUtil.toMomentObj(voyageStartUtcTime).format("YYYY年MM月DD日 HH:mm:ss");
        } else {
          playableStartTimeLabel = DateUtil.toMomentObj(targetStartUtcTime).format("YYYY年MM月DD日 HH:mm:ss");
        }
      } else {
        playableStartTimeLabel = DateUtil.toMomentObj(targetStartUtcTime).format("YYYY年MM月DD日 00:00:00");
      }

      if (DateUtil.isSameLocalDate(voyageEndUtcTime, targetEndUtcTime)) {
        if (DateUtil.toMomentObj(voyageEndUtcTime).isAfter(DateUtil.toMomentObj(targetEndUtcTime))) {
          playableEndTimeLabel = DateUtil.toMomentObj(voyageEndUtcTime).format("HH:mm:ss");
        } else {
          playableEndTimeLabel = DateUtil.toMomentObj(targetEndUtcTime).format("HH:mm:ss");
        }
      } else {
        playableEndTimeLabel = DateUtil.toMomentObj(targetEndUtcTime).format("24:00:00");
      }
      this.timeLabel  = `${playableStartTimeLabel} - ${playableEndTimeLabel}`;
    }
  },

  async mounted() {
    const parseFormat = 'YYYY-MM-DD-HH-mm-ss';
    const startUtcMoment = moment.utc(this.$route.query.startUtc, parseFormat);
    this.vessel = this.$route.query.vessel
    this.vesselName = this.vessel.name_ja || this.vessel.name || "UNKNOWN"

    if (!startUtcMoment.isValid() || !this.$route.query.id) {
      this.errorMsg = "航海履歴が見つかりません"
      this.hasError = true;
      return;
    }
    const startUtc = startUtcMoment.format();
    const endUtc = DateUtil.toMomentObj(startUtc).utc().add(60, 'm').format();

    const timeRange = this.$route.query.timeRange

    if(timeRange.startUtc && timeRange.startUtc) {
      this.setPlayableTime(timeRange.startUtc, timeRange.endUtc, startUtc, endUtc);
      this.setTargetPlayTime(startUtc, endUtc);

      let payload = {
        vesselId: this.vessel.id,
        startTimeUtc: this.startTimeUtc,
        endTimeUtc: this.endTimeUtc
      };
      await this.setVoyageHistoryDateTime(payload);
    } else {
      this.errorMsg = "再生時間が取得できませんでした。航海履歴一覧からページ再度遷移してください。"
      this.hasError = true;
      return;
    }

  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss">
.mapboxgl-ctrl-attrib-inner {
  display: none !important;
}
.mapboxgl-ctrl-bottom-right {
  display: block !important;
}
</style>

<style lang="scss">
#vessel-position-map {
  height: 580px;
  object-fit: scale-down;
}

#vessel-position-mode-label {
  margin: 20px;
  list-style: none;
  overflow: hidden;
  li {
    height: 40px;
    width: 100px;
    border-radius: 5px;
    text-align: center;
    background-color: #5097d5;
    p {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: 0 -50% 0 0;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
    }
  }
}
#vessel-position-area {
}
#vessel-position-live-camera-are {
  display: grid;
  grid-template-rows: 100px 50px;
  grid-template-columns: 200px 200px;
  #itemA {
    grid-area: areaA;
    background: #f88;
  }
  #itemB {
    grid-area: areaB;
    background: #8f8;
  }
  #itemC {
    grid-area: areaC;
    background: #88f;
  }
}

.live-camera-card {
  border-radius: 0 !important;
  .vx-card {
    border-radius: 0 !important;
  }
}
#player-controller-container {
  position: relative;
}

#timeline-controller-container {
  position: relative;
  background-color: #f2f2f2;
  height: 160px;
}

.map-overlay-container {
  color: black;
  position: absolute;
  width: 38%;
  top: 0;
  left: 0;
  padding: 10px;
  z-index: 1;
}

.map-overlay {
  color: black;
  background-color: #fff;
  border-radius: 3px;
  padding: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.map-overlay h2,
.map-overlay p {
  margin: 0 0 10px;
}

.mapboxgl-canvas {
  position: inherit !important;
}

.map-overlay-container-no-info {
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: black;
  border-radius: 3px;
  opacity: 0.8;
  .map-overlay-no-info {
    top: 50%;
    left: 50%;
    color: #fff;
    position: relative;
    p {
      position: absolute;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      height: 100%;
      width: 80%;
      text-align: center; /*一応BOX内の文字も中央寄せ*/
    }
  }
}
.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl {
  margin: 0 10px 40px 0 !important;
}
#vessel-style-change {
  margin-bottom: 10px !important;
}
</style>
